import React from 'react'
import ContainerLayout from '../../../../components/container-layout/ContainerLayout'
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom'
import { routeName } from '../../../../routes/routeName'
import StateComponents from '../../../../components/state-component/StateComponents'
import TableCustom from '../../../../components/table/tableCustom'
import { debouncedApiCall } from '../../../../utils/app.utils'
import { IconComponent } from '../../../../assets/icons/iconComponent'
import ContainerButton from '../../../../components/button/ContainerButton'
import ManageState from './manageState'
import ModalCustom from '../../../../components/modal/ModalCustom'
import { useTranslation } from 'react-i18next'

type Props = {}

const TagManage: React.FC<Props> = ({ }: Props) => {
    const { t } = useTranslation();
    const {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,
        setSearch,
        // handleDownloadReport,
        showModal,
        handleCloseModal,
        form,
        set_form,
        handleSubmitForm,
        setShowModal
    } = ManageState()
    return (
        <div className='w-full'>
            <ContainerLayout
                title={t("จัดการแท็ก")}
                hidden_sub_title
                navigateContent={
                    <NavigateListCustom
                        navigateData={[
                            {
                                key: "complaintSubmit",
                                name: t("ตั้งค่า"),
                                disabled_match: true,
                                pathName: ""
                            },
                            {
                                key: "complaintSubmit",
                                name: t("จัดการแท็ก"),
                                pathName: routeName.cms_website.GalleryTypeManagement
                            },
                        ]}
                    />
                }
                buttonContent={
                    // <ContainerButton
                    //     justifyContent='flex-end'
                    //     buttonData={[
                    //         {
                    //             buttonProps: {
                    //                 onClick: handleDownloadReport
                    //             },
                    //             key: "DOWNLOAD_CSV",
                    //             label: t("COMPLAINTS_DOWNLOAD_CSV"),
                    //             seq: 1,
                    //             type: "DOWNLOAD_CSV"
                    //         }
                    //     ]}
                    // />
                    <></>
                }
                content={
                    <div className='w-full'>
                        <div className='w-full gap-4 flex justify-between flex-col md:flex-row flex-wrap md:flex-nowrap items-center'>
                            <span className='flex-1'>
                                <StateComponents
                                    otherProps={{ spacing: 2 }}
                                    typeProps={[
                                        {
                                            seq: 1,
                                            type: "TEXT_FIELD",
                                            gridProps: {
                                                xs: 12,
                                                md: 6
                                            },
                                            fieldProps: {
                                                placeholder: t("ค้นหาชื่อจัดการแท็ก"),
                                                startAdornment: <IconComponent.SearchIcon />,
                                                onChange: (e) => debouncedApiCall({ searchItem: e.target.value, setItem: setSearch }),
                                            }
                                        },
                                    ]}
                                />
                            </span>
                            <span className='w-full md:w-auto'>
                                <ContainerButton
                                    buttonData={[
                                        {
                                            seq: 1,
                                            key: "ADD",
                                            buttonProps: {
                                                onClick: () => setShowModal("ADD")
                                            },
                                            label: t("เพิ่มจัดการแท็ก"),
                                            type: "ADD"
                                        }
                                    ]}
                                />
                            </span>

                        </div>


                        <div className='mt-10'>
                            <section className='w-full mt-10'>
                                <TableCustom
                                    tableMinWidth={1440}
                                    tableFixedWidth
                                    customScroll
                                    page={page}
                                    pageLimit={pageLimit}
                                    sortBy={sortBy}
                                    sortType={sortType}
                                    headCells={headCells}
                                    rowCount={totalItems}
                                    rowsData={data?.map((data: any, i: any) => {
                                        return renderData(data, i)
                                    })}
                                    onSort={handleRequestSort}
                                    setPageLimit={(value: number) => setPageLimit(value)}
                                    setPage={(value: number) => setPage(value)}
                                />
                            </section>
                        </div>
                    </div>
                }
            />

            {showModal !== '' && (
                <ModalCustom
                    open
                    title={showModal === 'ADD' ? t("เพิ่มจัดการแท็ก") : t("ข้อมูลจัดการแท็ก")}
                    subTitle={t("กรุณาระบุข้อมูลให้ครบถ้วนก่อนการยืนยัน")}
                    onClose={handleCloseModal}
                    containerButton={{
                        disabled_submit: !form.gallery_type_name,
                        hidden_submit: showModal === 'VIEW',
                        onClose: handleCloseModal,
                        onSubmit: () => handleSubmitForm()
                    }}
                    component={
                        <div className='w-full'>
                            <StateComponents
                                disabledAllField={showModal === 'VIEW'}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12
                                        },
                                        fieldProps: {
                                            heading: t("ชื่อจัดการแท็ก"),
                                            required: true,
                                            value: form.gallery_type_name,
                                            onChange: (e) => set_form((prev) => ({ ...prev, gallery_type_name: e.target.value }))
                                        }
                                    }
                                ]}
                            />
                        </div>
                    }
                />
            )}
        </div>
    )
}

export default TagManage